import { render, staticRenderFns } from "./XolasTable.vue?vue&type=template&id=732f0cbc&scoped=true"
import script from "./XolasTable.vue?vue&type=script&lang=js"
export * from "./XolasTable.vue?vue&type=script&lang=js"
import style0 from "./XolasTable.vue?vue&type=style&index=0&id=732f0cbc&prod&scoped=true&lang=css"
import style1 from "./XolasTable.vue?vue&type=style&index=1&id=732f0cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f0cbc",
  null
  
)

export default component.exports